module.exports = __webpack_public_path__ + "static/formation-deformation_2017-1485lx126wcm-acrylic-paper-2f760dedf09c7bc16c96b028c2709a98.jpg";